import { Box, Pagination } from '@primer/react';
import Button from '../ui/button';
interface IPagingProps {
    pageSizeItems?: number[];
    pageSize: number;
    pageIndex: number;
    pageCount: number;
    totalCount: number;
    onPagingChanged: (pageIndex: number, pageSize: number) => void
}
const Paging = (props: IPagingProps) => {
    const { pageSizeItems, pageIndex, pageSize, pageCount, totalCount, onPagingChanged } = props;
    return (
        <Box
            id="paging"
            sx={{
                display: "flex",
                alignItems: "center",
            }}
        >
            <Box sx={{ flex: 1 }}>
                {pageSizeItems && (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Box
                            sx={{
                                fontSize: "11px",
                                color: "fg.muted",
                            }}
                        >
                            Page size&nbsp;&nbsp;
                        </Box>
                        {pageSizeItems.map((x) => {
                            return (
                                <Button
                                    key={x}
                                    // className={clsx(
                                    //     styles.pageSize,
                                    //     x === pageSize ? styles.selected : ""
                                    // )}
                                    variant="invisible"
                                    sx={{
                                        // color: "fg.default",
                                        fontWeight: 400,
                                        backgroundColor: x === pageSize ? "accent.emphasis" : undefined,
                                        color: x === pageSize ? "accent.subtle" : "fg.default",
                                    }}
                                    size="small"
                                    onClick={() => {
                                        onPagingChanged(0, x)
                                    }}
                                >
                                    {x.toString()}
                                </Button>
                            );
                        })}
                    </Box>
                )}
            </Box>
            <Box id="info" sx={{ width: "100px", textAlign: "center" }}>
                <Box
                    sx={{
                        color: "fg.muted",
                    }}
                >
                    {pageIndex * pageSize + 1} -{" "}
                    {(pageIndex + 1) * pageSize > totalCount
                        ? totalCount
                        : (pageIndex + 1) * pageSize}{" "}
                    of {totalCount}
                </Box>
            </Box>
            <Box
                sx={{ flex: 1, display: "flex", flexDirection: "row-reverse" }}
            >
                {pageCount > 1 && (
                    <Pagination
                        pageCount={pageCount}
                        currentPage={pageIndex + 1}
                        showPages={{
                            narrow: false,
                        }}
                        onPageChange={(e, n) => {

                            onPagingChanged(n - 1, pageSize)
                        }}
                    />
                )}
            </Box>
        </Box>
    );
};

export default Paging;